import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { CostReviewLineItemService } from '../cost-review-line-item/cost-review-line-item-service';

import styles from './styles.module.css';
import { InsuranceProviders, getInsuranceProviderById } from '../../enums/insurance-providers';

export const WalletedCostReviewInsuranceGroup = ({ insuranceCost }) => {
  const { subTotal, insuranceProviderId } = insuranceCost;

  const { messageDescriptor: serviceNameMessageDescriptor, name: providerName } = getInsuranceProviderById(insuranceProviderId);

  return (
    <>
      <div className={styles['walleted-provider-header-line']}>{providerName}</div>
      <CostReviewLineItemService serviceCost={subTotal} serviceName={<FormattedMessage {...serviceNameMessageDescriptor} />} />
    </>
  );
};

WalletedCostReviewInsuranceGroup.propTypes = {
  insuranceCost: PropTypes.shape({
    subTotal: PropTypes.number.isRequired,
    insuranceProviderId: PropTypes.oneOf(Object.values(InsuranceProviders).map((x) => x.insuranceProviderId)).isRequired,
  }).isRequired,
};
